import compact from 'lodash/compact';
import s from '../selectors';
import Logger from '../../Logger';

/**
 * selectLocation - user has chosen a location from the dropdown. Use it to update defaults.
 * @param {Sting} locale
 */
export default locale => (_dispatch, getState, i18n) => {
  const state = getState();
  const widgetSource = s.widgetSource(state);

  let effectiveLocale = locale;
  if (locale === 'en' && widgetSource === 'ontario') {
    effectiveLocale = 'en_CA';
  }

  i18n.changeLanguage(effectiveLocale, (err, t) => {
    if (err) {
      Logger.error(err);
    }
    const translatedRoute = compact(window.location.pathname.split('/')).slice(1).map(path => t(path, { ns: 'routes' }));
    window.location = `/${effectiveLocale}/${translatedRoute.join('/')}`;
  });
};
